import { render } from "./MagnificPopUp.vue?vue&type=template&id=0a68c62a"
import script from "./MagnificPopUp.vue?vue&type=script&lang=js"
export * from "./MagnificPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__